<template>
  <a-table :scroll="{ x: 900, y: 400 }" :pagination="false" size="small" :columns="columns" row-key="version_id" :data-source="dataSource" bordered>
    <template slot="customId" slot-scope="text, record"> PR-{{ record.id }} </template>
    <template slot="customTitle" slot-scope="text, record">
      <a :href="link(record)" target="_blank">{{ `[PR-${record.id}]${record.title}; ` }}</a>
    </template>
  </a-table>
</template>

<script>
const columns = [
  {
    title: 'ID',
    width: 80,
    scopedSlots: { customRender: 'customId' }
  },
  {
    title: '标题',
    width: 300,
    scopedSlots: { customRender: 'customTitle' }
  },
  {
    title: '处理时长',
    width: 120,
    key: 'response_time',
    dataIndex: 'response_time'
  }
];
export default {
  props: {
    dataSource: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      columns
    };
  },
  computed: {
    link() {
      return record => {
        return this.$router.resolve({
          name: 'page:project:quality:issue:detail',
          params: {
            project_id: record.project_id
          },
          query: { issueId: record.id }
        }).href;
      };
    }
  }
};
</script>
<style lang="less" scoped>
.link {
  display: block;
}
</style>
